import { useDispatch } from 'react-redux'

import { useMutation } from '@tanstack/react-query'
import { addToFavorites, removeFromFavorites } from 'containers/GamesBlock/service'
import { addFlashMessage, toggleGameFavorite } from 'containers/MainLayout/actions'

interface Props {
  slug: string
  isFavorite: boolean
}

export default function useMutateFavorites({ slug, isFavorite }: Props) {
  const dispatch = useDispatch()

  return useMutation({
    mutationFn: () => {
      dispatch(toggleGameFavorite(slug))

      if (isFavorite) {
        return removeFromFavorites(slug)
      }

      return addToFavorites(slug)
    },
    onError: (error: any) => {
      const message = error?.message || error?.error?.message || error?.data

      dispatch(addFlashMessage(message, 'error'))
      dispatch(toggleGameFavorite(slug))
    },
  })
}
